const state = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  premium: JSON.parse(localStorage.getItem("premium")) || { is_premium: false, premium_until: null, days_left: 0 },
}

const getters = {
  user: (state) => state.user,
  accessToken: (state) => state.accessToken,
  refreshToken: (state) => state.refreshToken,
  isAuthenticated: (state) => !!state.accessToken,
  isPremium: (state) => state.premium?.is_premium || false,
  premiumInfo: (state) => state.premium || {},
}

const mutations = {
  SET_AUTH(state, { user, access, refresh, premium }) {
    state.user = user
    state.accessToken = access
    state.refreshToken = refresh
    if (premium) {
      state.premium = premium
      localStorage.setItem("premium", JSON.stringify(premium))
    }

    localStorage.setItem("user", JSON.stringify(user || {}))
    localStorage.setItem("accessToken", access)
    localStorage.setItem("refreshToken", refresh)
  },

  SET_PREMIUM(state, premium) {
    state.premium = premium
    localStorage.setItem("premium", JSON.stringify(premium))
  },

  UPDATE_ACCESS_TOKEN(state, access) {
    state.accessToken = access
    localStorage.setItem("accessToken", access)
  },

  UPDATE_REFRESH_TOKEN(state, refresh) {
    state.refreshToken = refresh
    localStorage.setItem("refreshToken", refresh)
  },

  LOGOUT(state) {
    state.user = null
    state.accessToken = null
    state.refreshToken = null
    state.premium = { is_premium: false, premium_until: null, days_left: 0 }

    localStorage.removeItem("user")
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")
    localStorage.removeItem("premium")
  },
}

import api from '@/api/axios'

const actions = {
  async login({ commit }, payload) {
    try {
      const response = await api.post('/account/login/', payload)
      const data = response.data

      const access  = data.access  || (data.tokens && data.tokens.access)
      const refresh = data.refresh || (data.tokens && data.tokens.refresh)
      const user    = data.user || null
      const premium = data.premium || { is_premium: false, premium_until: null, days_left: 0 }

      if (!access || !refresh) {
        console.error("Backend javobida token topilmadi → ", data)
        throw new Error("access yoki refresh token yo'q")
      }

      commit("SET_AUTH", { user, access, refresh, premium })
      return data
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data
      }
      throw error
    }
  },

  async refreshToken({ state, commit, dispatch }) {
    if (!state.refreshToken) {
      dispatch("logout")
      throw new Error("Refresh token yo'q")
    }

    const response = await fetch(`${API_BASE}/account/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh: state.refreshToken }),
    })

    const data = await response.json()

    if (!response.ok) {
      dispatch("logout")
      throw data
    }

    commit("UPDATE_ACCESS_TOKEN", data.access)
    if (data.refresh) commit("UPDATE_REFRESH_TOKEN", data.refresh)

    return data
  },

  async fetchPremiumStatus({ state, commit }) {
    if (!state.accessToken) return
    try {
      const response = await api.get('/account/me/')
      if (response.data) {
        const data = response.data
        commit("SET_PREMIUM", {
          is_premium: data.is_premium || data.is_staff || data.is_superuser || false,
          premium_until: data.premium_until,
          days_left: data.days_left || 0
        })
      }
    } catch (e) {
      console.error("Premium status olishda xatolik:", e)
    }
  },

  logout({ commit }) {
    commit("LOGOUT")
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}